import { useCallback } from 'react'
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom'
import { useTranslations } from '@/core/translation'
import { useDeviceType, usePackageInfo, ROUTES } from '@/utils'
import { useAppSelector } from '@/redux/core'
import { selectIsAuthenticated } from '@/redux/auth'
import { useUserExperiences } from '@/core/userExperience'
import { CartDrawerProps } from './CartDrawer.types'
import { CHECKOUT_FLOW_ROUTES } from './CartDrawer.data'

export const useCartDrawerController = ({ onClose }: Pick<CartDrawerProps, 'onClose'>) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isMobile } = useDeviceType()
  const { productCount, currentPackage } = usePackageInfo()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const { isDirectCheckoutEnabled } = useUserExperiences()
  const t = useTranslations('cart')

  const isInCheckoutFlow = CHECKOUT_FLOW_ROUTES.some((route) => location.pathname.startsWith(route))

  const onCheckout = useCallback(() => {
    onClose()

    if (isInCheckoutFlow) return

    navigate({
      pathname:
        isDirectCheckoutEnabled || isAuthenticated
          ? ROUTES.PACKAGE.CHECKOUT
          : ROUTES.PACKAGE.CONTACT_INFO,
      search: createSearchParams({ sessionId: currentPackage?.sessionId ?? '' }).toString(),
    })
  }, [
    currentPackage?.sessionId,
    isDirectCheckoutEnabled,
    isInCheckoutFlow,
    onClose,
    navigate,
    isAuthenticated,
  ])

  return { t, isMobile, productCount, onCheckout, isInCheckoutFlow }
}
